import { render, staticRenderFns } from "./NavigationMailbox.vue?vue&type=template&id=3d68d72b&scoped=true"
import script from "./NavigationMailbox.vue?vue&type=script&lang=js"
export * from "./NavigationMailbox.vue?vue&type=script&lang=js"
import style0 from "./NavigationMailbox.vue?vue&type=style&index=0&id=3d68d72b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d68d72b",
  null
  
)

export default component.exports